var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('ui-loader',{attrs:{"lazy":true}},[_c('ui-stats')],1),_c('div',{attrs:{"id":"network"}})],1),_c('analytics',{ref:"analytics",attrs:{"state":_vm.state,"config":_vm.config}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }